export default __webpack_public_path__ + "static/media/biking.55879ebe.jpg";